import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube, Twitter, MessageCircle, ShieldCheck, Award } from 'lucide-react';
import { COMPANY, DESTINATIONS, HOLIDAY_TYPES } from '../../mock';

const LOGO_URL = '/images/Dashboard/Assets/Images/profile_img/mct p2.png';

export default function Footer() {
  return (
    <footer className="bg-brand-blue text-white pt-16 pb-6 mt-20">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <Link to="/" className="inline-block bg-white/95 rounded-xl p-3">
            <img src={LOGO_URL} alt="Mountains Chain Travel" className="h-14 w-auto" />
          </Link>
          <p className="text-white/70 text-sm mt-5 leading-relaxed max-w-md">North India's most trusted travel partner since 2015. Himachal, Kashmir & Leh-Ladakh specialists - plus tours across India and abroad. A registered Pvt. Ltd. company, Ministry of Tourism approved.</p>
          <div className="flex gap-3 mt-5">
            <a href={COMPANY.social.facebook} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-orange flex items-center justify-center transition-colors" aria-label="Facebook"><Facebook size={16} /></a>
            <a href={COMPANY.social.instagram} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-orange flex items-center justify-center transition-colors" aria-label="Instagram"><Instagram size={16} /></a>
            <a href={COMPANY.social.youtube} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-orange flex items-center justify-center transition-colors" aria-label="YouTube"><Youtube size={16} /></a>
            <a href={COMPANY.social.twitter} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-orange flex items-center justify-center transition-colors" aria-label="Twitter"><Twitter size={16} /></a>
            <a href={`https://wa.me/${COMPANY.whatsapp}`} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-orange flex items-center justify-center transition-colors" aria-label="WhatsApp"><MessageCircle size={16} /></a>
          </div>
        </div>

        <div>
          <h4 className="font-poppins font-semibold mb-4 text-[15px]">Destinations</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            {DESTINATIONS.map(d => (
              <li key={d.slug}><Link to={`/destinations/${d.slug}`} className="hover:text-brand-orange transition-colors">{d.name}</Link></li>
            ))}
            <li><Link to="/destinations" className="hover:text-brand-orange transition-colors">All Destinations</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-poppins font-semibold mb-4 text-[15px]">Holidays</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            {HOLIDAY_TYPES.slice(0,6).map(h => (
              <li key={h.slug}><Link to={h.slug === 'international' ? '/international' : h.slug === 'domestic' ? '/domestic' : `/holidays/${h.slug}`} className="hover:text-brand-orange transition-colors">{h.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-poppins font-semibold mb-4 text-[15px]">Company</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/about" className="hover:text-brand-orange transition-colors">About Us</Link></li>
            <li><Link to="/how-it-works" className="hover:text-brand-orange transition-colors">How It Works</Link></li>
            <li><Link to="/blog" className="hover:text-brand-orange transition-colors">Blog</Link></li>
            <li><Link to="/packages" className="hover:text-brand-orange transition-colors">All Packages</Link></li>
            <li><Link to="/contact" className="hover:text-brand-orange transition-colors">Contact</Link></li>
          </ul>
          <h4 className="font-poppins font-semibold mt-6 mb-3 text-[15px]">Reach Us</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li className="flex gap-2"><Phone size={14} className="mt-0.5 text-brand-orange shrink-0"/><a href={`tel:${COMPANY.phone}`}>{COMPANY.phone}</a></li>
            <li className="flex gap-2"><Mail size={14} className="mt-0.5 text-brand-orange shrink-0"/><a href={`mailto:${COMPANY.email}`} className="break-all">{COMPANY.email}</a></li>
            <li className="flex gap-2"><MapPin size={14} className="mt-0.5 text-brand-orange shrink-0"/><span>{COMPANY.address}</span></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/50">
        <div>© {new Date().getFullYear()} Mountains Chain Booking Holidays India Pvt. Ltd. All rights reserved.</div>
        <div className="flex items-center gap-4"><span className="flex items-center gap-1.5"><ShieldCheck size={12} className="text-brand-orange"/>Govt. Approved</span><span className="flex items-center gap-1.5"><Award size={12} className="text-brand-orange"/>IATA & ADTOI</span></div>
      </div>
    </footer>
  );
}
